import { FC, useContext } from 'react';
import { DateRangeFilter, TableContext } from './';
import { QuickFilterTooltip } from './QuickFilterTooltip';
import { CbSelect } from '../CbSelect';
import { FilterConfig, FilterType } from 'hooks/useTable';
import { UserSelectFilter } from './UserSelectFilter';
import styles from './QuickFilters.module.css';
export const QuickFilters: FC = () => {
  const {
    quickFilterInfo,
    updateFilter
  } = useContext(TableContext);
  return <div className={styles.container} data-sentry-component="QuickFilters" data-sentry-source-file="QuickFilters.tsx">
      {quickFilterInfo.map(filter => {
      const {
        columnId,
        filterConfig,
        quickFilterTooltipContent: tooltip,
        value
      } = filter as {
        columnId: string;
        filterConfig: FilterConfig;
        quickFilterTooltipContent: string | null;
        value: string;
      };
      if (filterConfig.type === FilterType.DateRange) {
        return <DateRangeFilter columnId={columnId} isQuickFilter key={columnId} />;
      }
      if (filterConfig.type === FilterType.UserSelection) {
        const handleChange = (value: string) => updateFilter({
          columnId,
          value
        });
        return <QuickFilterTooltip content={tooltip}>
              <UserSelectFilter columnId={columnId} key={columnId} onChange={handleChange} value={value} />
            </QuickFilterTooltip>;
      }
      const formattedOptions = filterConfig.options.map(opt => ({
        name: opt.label,
        value: opt.value
      }));
      const handleChange = ({
        value
      }: {
        value: string;
      }) => updateFilter({
        columnId,
        value
      });
      const selectedOption = formattedOptions.find(opt => opt.value === value);
      return <div className={styles.quickFilter} key={columnId}>
            <QuickFilterTooltip content={tooltip}>
              <CbSelect borderColor="cloud.600" getValueFromOption={option => option.value} onChange={handleChange} options={formattedOptions} size="sm" value={selectedOption} />
            </QuickFilterTooltip>
          </div>;
    })}
    </div>;
};